import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams
} from "ionic-angular";
import { HkApiproviderProvider } from "../../providers/hk-apiprovider/hk-apiprovider";
import { LanguageServiceProvider } from '../../providers/language-service/language-service';
@IonicPage()
@Component({
  selector: "page-notidetails",
  templateUrl: "notidetails.html"
})
export class NotiDetailsPage {
  public resposeData: any;
  userDetails: any;
  postData = {
    user_id:"",
    role:'1',
    token: "",
    lang:"",
    noti_id:"",
    id:"",
    image_type:"notification",
    noofImage:0,
    details_page:"1",
  };
  imgs:Array<any>;
  fname:any;
  create_date:any;
  image:any;
  title:any;
  description:any;
  public NotidataSet: any;
  alert_message:any = [];
  notibaseImageUrl:any;
  selectedImg:any;
  selectedId:any;
  constructor(
    public navCtrl: NavController,
    public langserv : LanguageServiceProvider,
    public navParams: NavParams,
    public auth: HkApiproviderProvider
  ) {
      this.postData.token = HkApiproviderProvider.gettoken();
      if(localStorage.getItem('userData')){
        const data = JSON.parse(localStorage.getItem('userData'));
        this.userDetails = data.userData;
        this.postData.user_id = this.userDetails.user_id;
        this.postData.token = this.userDetails.token;
        this.postData.role = this.userDetails.role;
      }
      this.notibaseImageUrl = this.auth.getNotiimage();
      this.postData.lang = localStorage.getItem('language');
      this.langserv.changelang(this.postData.lang);
      this.postData.noti_id = navParams.get("id");
      this.postData.id = this.postData.noti_id;
      this.getField();
      this.getImages();
  }
  getImg(id,img){
    console.log(img);
    this.selectedImg=this.notibaseImageUrl+"/"+id+"/"+img;
    this.selectedId = id;
  }
  
  getImages(){
    let zest = this.auth.loadingMessage('fetchingData');
    zest.present();
    console.log(this.postData);
    this.auth.postData(this.postData, "getImages").then(
    result => {
      this.resposeData = result;
    	if(this.resposeData.gallery){
            this.imgs=this.resposeData.gallery;
            console.log(this.imgs);
            if(this.imgs.length > 0){
              this.selectedImg = this.notibaseImageUrl+this.postData.noti_id+"/"+this.resposeData.gallery[0].image;
              this.postData.noofImage = this.imgs.length;
            }
            zest.dismiss();
    	} else{
        zest.dismiss();
      }
    },
    err => {
    zest.dismiss();
    }
    );
  }
  getField() {
    let zest = this.auth.loadingMessage('message_get_Noti');
    zest.present();
    console.log(this.postData);
    this.auth.postData(this.postData, "getnotificationDetails").then(
      result => {
        this.resposeData = result;
        console.log(this.resposeData);
        this.image = this.resposeData.image;
        this.title = this.resposeData.title;
        this.description = this.resposeData.description;
        this.create_date = this.resposeData.create_date;
        this.fname = this.resposeData.fname;
        zest.dismiss();
      },
      err => {
        zest.dismiss();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/notidetails/notidetails.ts